export class UIRules {
    componentTypes: ComponentTypes[];
}

export class ComponentTypes {
    component: string;
    attributes: Attributes[];

}


export class Attributes {
    attributeId: string;
    attributeName: string;
    attributeLabel: string;
    type: string;
    logic: string;
    ConfigurationType: string;
    refList: RefList[];
    source: Source[];
    updatedQuestionText?: string;
    validators: Validate;
}
export class RefList {
    refAttributeId: string;
    refAttributeCode: string;
    minValue: number;
    maxValue: number;
    displayOnScreen: boolean;
    enableOnScreen: boolean;
    lookupvalues: Source[];
}

export class Validate {
    required: boolean;
}
export class Source {
    code: string;
    value: string;
    agencyNo: number;
    dealCode: string;
    displayRule: DisplayRule[];
    validators: Validators;
    defaultValue?: boolean;
}
export class DisplayRule {
    attributeName: string;
    attributeType: string;
    operator: string;
    value: [string];
}

export class Validators {
    required: [Required];
}

export class Required {
    fact: string;
    operator: string;
    value: [string]
}

export class JourneyLockDownData {
    channel: string;
    source: string;
    sourceValue: string;
    agencyNo: number;
    dealCode: string;
    product: string;
    productCodeModels: string;
    valuationExpiryDate: string;
}

export class DisplayRuleToBeApplied {
    attNameToCompare: string;
    valueToCompare: string;

    constructor(attNameToCompare: string, valueToCompare: string) {
        this.attNameToCompare = attNameToCompare;
        this.valueToCompare = valueToCompare;
    }
}
